var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(_vm.detail.type === 'word')?_c('preview-word',{attrs:{"wordURL":_vm.detail.content}}):_vm._e(),(_vm.detail.type === 'pdf')?_c('preview-pdf',{attrs:{"pdfUrl":_vm.detail.content}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }